"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/formFill/Header.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);








/* The form's name, then who it is about and View the page. */
const Header = ({ title, details, onViewPage, children }) => (
  _react2.default.createElement('div', { className: "form-fill--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
    , _react2.default.createElement('h1', { className: "form-fill--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}},  title )
    , _react2.default.createElement('div', { className: "form-fill--details", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      ,  details.filter(Boolean).join(' · ') 
      ,  ' · ' 
      , _react2.default.createElement('button', { type: "button", className: "form-fill--link", onClick: onViewPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}, "View the page"  )
    )
    ,  children 
  )
)

exports. default = Header
